import { getAuth } from "firebase/auth";
import axios from "axios";

const apiPayout = axios.create({
	baseURL: process.env.REACT_APP_URL_API_PAYOUT,
	headers: {
		"content-type": "application/json",
	},
});

apiPayout.interceptors.request.use(async (config) => {
	const accessToken= localStorage.getItem('accessToken');
	let token = accessToken ? accessToken : null;

	const currentUser = getAuth().currentUser;

	if (currentUser) {
		token = currentUser.accessToken;
		config.headers.Authorization = `Bearer ${token}`;
	} else if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	} else {
		config.headers.Authorization = null;
	}

	config.headers["User-Agent"] = "WebBusiness";

	return config;
}, (error) => {
  return Promise.reject(error);
});

export default apiPayout;
